<!-- 
System: GIGSTIMER
Developer(s): Fatima Saeed, Jazib Nasir
Date: --/--/--
Organization: Programmers Force
Purpose: Payment chart for Pricing according to features
-->
<template>
  <div>
    <v-row class="d-flex justify-center">
      <v-card-title style="color: #36454f; font-size: 30px" 
        >Find the right plan for your team</v-card-title
      >
    </v-row>
    <div class="d-flex justify-center mt-1">
      <div
        class="hover-btn bold"
        rounded
        style="color: #28806d"
        color="#e4f6f2"
      >
        <!-- Total number of active members -->
        <h3>Total Number of Team members : {{ getActiveMembers.length }}</h3>
      </div>
    </div>
    <!-- Switch between Monthly and Yearly Pricing and Subscription -->
    <div class="d-flex justify-center mt-2">
      <v-card class="d-flex justify-center" width="250px">
        <div class="d-flex flex-row pointer py-1">
          <div
            class="my-2 mx-1 px-3 py-1"
            :class="planPeriod == 'month' ? 'active' : ''"
            @click="
              (cardDetail.stripe_plan = 'monthly'), (planPeriod = 'month')
            "
          >
            Monthly
          </div>
          <div
            class="my-2 mx-1 px-3 py-1"
            :class="planPeriod == 'year' ? 'active' : ''"
            @click="(cardDetail.stripe_plan = 'yearly'), (planPeriod = 'year')"
          >
            Yearly
          </div>
        </div>
      </v-card>
    </div>
    <v-row :class="$vuetify.breakpoint.smAndDown ? '' : 'mx-5 mt-2'">
      <v-col cols="12" sm="6" md="6" lg="3" xl="3">
        <!-- Card for Basic Plan Features -->
        <v-card
          style="border-radius: 5%"
          :class="$vuetify.breakpoint.lgAndDown ? 'mb-1 mx-1' : 'mx-16 mb-1'"
        >
          <v-toolbar
            dark
            color="#e5dafc"
            height="138px"
            class="d-flex justify-center text-center"
            style="color: #36454f"
          >
            <div>
              <h1>Basic</h1>
              <h3 style="color: #7044d5">Free</h3>
            </div>
          </v-toolbar>
          <v-card>
            <v-container>
              <v-list flat>
                <v-list-item-group class="text-center">
                  <v-list-item id="clrClass"
                    ><v-icon small color="#5a339d">mdi-check-bold</v-icon>
                    <h5 class="ml-2">Upto 10 Team Member</h5></v-list-item
                  >
                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#5a339d">mdi-check-bold</v-icon>
                    <h5 class="ml-2">1 Project</h5></v-list-item
                  >

                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#5a339d">mdi-check-bold</v-icon>
                    <h5 class="ml-2">Time Tracking</h5></v-list-item
                  >
                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#5a339d">mdi-check-bold</v-icon>
                    <h5 class="ml-2">Smart Chatbox</h5></v-list-item
                  >
                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#5a339d">mdi-check-bold</v-icon>
                    <h5 class="ml-2">Task List View Only</h5></v-list-item
                  >
                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#5a339d">mdi-check-bold</v-icon>
                    <h5 class="ml-2">Push-to-talk</h5></v-list-item
                  >

                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#5a339d">mdi-check-bold</v-icon>
                    <h5 class="ml-2">Reports</h5></v-list-item
                  >
                  
                  <v-list-item class="d-flex justify-center mt-n4" id="clrClass"
                    ><h5></h5
                  ></v-list-item>
                  <v-list-item class="d-flex justify-center mt-n4" id="clrClass"
                    ><h5></h5
                  ></v-list-item>
                  <v-list-item class="d-flex justify-center mt-n4" id="clrClass"
                    ><h5></h5
                  ></v-list-item>
                  <v-list-item class="d-flex justify-center mt-n4" id="clrClass"
                    ><h5></h5
                  ></v-list-item>
                   <v-list-item class="d-flex justify-center mt-n4" id="clrClass"
                    ><h5></h5
                  ></v-list-item>
                </v-list-item-group>
              </v-list>
              <v-btn
                width="233px"
                class="mb-4 elevation-0"
                dark
                color="white"
              ></v-btn>
            </v-container>
          </v-card>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="6" lg="3" xl="3" v-if="planPeriod == 'month'">
        <!-- Card for Professional Monthly Plan Features and Pricing-->
        <v-card
          style="border-radius: 5%"
          :class="$vuetify.breakpoint.lgAndDown ? 'mb-1 mx-1' : 'mx-16 mb-1'"
        >
          <v-toolbar
            height="138px"
            class="d-flex justify-center"
            style="background-color: #d3f3fd"
          >
            <div class="d-flex flex-column text-center">
              <div>
                <h2 style="color: #36454f">Professional</h2>
              </div>
              <h3 style="color: #46b1da">Monthly</h3>
              <div style="color: #46b1da">
                <b>&dollar;{{ professional_amount ? '5.49' : professional_amount }}</b> / member
              </div>
            </div>
          </v-toolbar>
          <v-card>
            <v-container>
              <v-list flat>
                <v-list-item-group>
                  <v-list-item text--purple id="clrClass">
                    <v-icon small color="#4fb0f3">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">50 Team Member per Project</h5>
                  </v-list-item>
                  <v-list-item class="mt-n4" id="clrClass">
                    <v-icon small color="#4fb0f3">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">
                      Upto 5 Projects
                    </h5></v-list-item
                  >
                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#4fb0f3">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">Time Tracking</h5></v-list-item
                  >
                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#4fb0f3">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">Smart Chatbox</h5></v-list-item
                  >
                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#4fb0f3">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">
                      Task List and Kanban View
                    </h5></v-list-item
                  >
                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#4fb0f3">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">Push-to-talk</h5></v-list-item
                  >

                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#4fb0f3">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">Reports</h5></v-list-item
                  >
                     <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#4fb0f3">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">Schedule Messages</h5></v-list-item
                  >
                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#4fb0f3">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">
                      Screen Recording
                    </h5></v-list-item
                  >
                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#4fb0f3">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">
                      Multiple App Integrations
                    </h5></v-list-item
                  >
                  
                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#4fb0f3">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">
                      7 Days Free trial with Credit Card
                    </h5></v-list-item
                  >
                  <v-list-item
                    class="d-flex justify-center mt-n4"
                    id="clrClass"
                  ></v-list-item>
                </v-list-item-group>
              </v-list>
              <div class="d-flex align-center justify-center">
                <!-- Button for Professional Monthly Plan Subscription-->
                <v-btn
                  width="233px"
                  class="mb-4"
                  dark
                  color="#46b1da"
                  @click="openModel('professional')"
                  >Subscribe Now</v-btn
                >
              </div>
            </v-container>
          </v-card>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="6"
        lg="3"
        xl="3"
        v-else-if="planPeriod == 'year'"
      >
        <!-- Card for Professional Yearly Plan Features and Pricing-->
        <v-card
          style="border-radius: 5%"
          :class="$vuetify.breakpoint.lgAndDown ? 'mb-1 mx-1' : 'mx-16 mb-1'"
        >
          <v-toolbar
            height="138px"
            class="d-flex justify-center"
            style="background-color: #d3f3fd"
          >
            <div class="d-flex flex-column text-center">
              <div>
                <h2 style="color: #36454f">Professional</h2>
              </div>
              <h3 style="color: #46b1da">Yearly</h3>
              <div style="color: #46b1da">
                <b>&dollar;{{ professional_amount }}</b> / member
              </div>
            </div>
          </v-toolbar>
          <v-card>
            <v-container>
              <v-list flat>
                <v-list-item-group>
                  <v-list-item text--purple id="clrClass">
                    <v-icon small color="#4fb0f3">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">50 Team Member per Project</h5>
                  </v-list-item>
                  <v-list-item class="mt-n4" id="clrClass">
                    <v-icon small color="#4fb0f3">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">
                      Upto 5 Projects
                    </h5></v-list-item
                  >
                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#4fb0f3">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">Time Tracking</h5></v-list-item
                  >
                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#4fb0f3">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">Smart Chatbox</h5></v-list-item
                  >
                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#4fb0f3">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">
                      Task List and Kanban View
                    </h5></v-list-item
                  >
                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#4fb0f3">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">Push-to-talk</h5></v-list-item
                  >

                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#4fb0f3">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">Reports</h5></v-list-item
                  >
                   <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#4fb0f3">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">Schedule Messages</h5></v-list-item
                  >
                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#4fb0f3">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">
                      Screen Recording
                    </h5></v-list-item
                  >
                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#4fb0f3">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">
                      Multiple App Integrations
                    </h5></v-list-item
                  >
                 
                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#4fb0f3">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">
                      7 Days Free trial with Credit Card
                    </h5></v-list-item
                  >
                  <v-list-item
                    class="d-flex justify-center mt-n4"
                    id="clrClass"
                  ></v-list-item>
                </v-list-item-group>
              </v-list>
              <div class="d-flex align-center justify-center">
                <!-- Button for Professional Yearly Plan Subscription-->
                <v-btn
                  width="233px"
                  class="mb-4"
                  dark
                  color="#46b1da"
                  @click="openModel('professional')"
                  >Subscribe Now</v-btn
                >
              </div>
            </v-container>
          </v-card>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="6" lg="3" xl="3" v-if="planPeriod == 'month'">
        <!-- Card for Business Plus Monthly Plan Features and Pricing-->
        <v-card
          style="border-radius: 5%"
          :class="$vuetify.breakpoint.lgAndDown ? 'mb-1 mx-1' : 'mx-16 mb-1'"
        >
          <v-toolbar
            height="138px"
            class="d-flex justify-center"
            style="background-color: #feedb1"
          >
            <div class="d-flex flex-column text-center">
              <div>
                <h2 style="color: #36454f">Business Plus</h2>
              </div>
              <h3 style="color: #c89d36">Monthly</h3>
              <div style="color: #c89d36">
                <b>&dollar;{{ business_plus_amount ? '9.99' : business_plus_amount }}</b> / member
              </div>
            </div>
          </v-toolbar>
          <v-card>
            <v-container>
              <v-list flat>
                <v-list-item-group>
                  <v-list-item text--purple id="clrClass">
                    <v-icon small color="#c89d36">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">Unlimited Team Members</h5>
                  </v-list-item>
                  <v-list-item class="mt-n4" id="clrClass">
                    <v-icon small color="#c89d36">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">
                      Unlimited Projects
                    </h5></v-list-item
                  >
                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#c89d36">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">Time Tracking</h5></v-list-item
                  >
                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#c89d36">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">Smart Chatbox</h5></v-list-item
                  >
                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#c89d36">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">
                      Task List and Kanban View
                    </h5></v-list-item
                  >
                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#c89d36">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">Push-to-talk</h5></v-list-item
                  >

                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#c89d36">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">Reports</h5></v-list-item
                  >
                     <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#c89d36">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">Schedule Messages</h5></v-list-item
                  >
                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#c89d36">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">
                      Screen Recording
                    </h5></v-list-item
                  >
                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#c89d36">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">
                      Multiple App Integrations
                    </h5></v-list-item
                  >
                 
                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#c89d36">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">
                      Custom Subdomain
                    </h5></v-list-item
                  >
                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#c89d36">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">
                      1 Month trial with Credit Card
                    </h5></v-list-item
                  >
                </v-list-item-group>
              </v-list>
              <div class="d-flex align-center justify-center">
                <!-- Button for Business Monthly Plan Subscription-->
                <v-btn
                  width="233px"
                  class="mb-4"
                  dark
                  color="#c89d36"
                  @click="openModel('business_plus')"
                  >Subscribe Now</v-btn
                >
              </div>
            </v-container>
          </v-card>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="6"
        lg="3"
        xl="3"
        v-else-if="planPeriod == 'year'"
      >
        <!-- Card for Business Plus Yearly Plan Features and Pricing-->
        <v-card
          style="border-radius: 5%"
          :class="$vuetify.breakpoint.lgAndDown ? 'mb-1 mx-1' : 'mx-16 mb-1'"
        >
          <v-toolbar
            height="138px"
            class="d-flex justify-center"
            style="background-color: #feedb1"
          >
            <div class="d-flex flex-column text-center">
              <div>
                <h2 style="color: #36454f">Business Plus</h2>
              </div>
              <h3 style="color: #c89d36">Yearly</h3>
              <div style="color: #c89d36">
                <b>&dollar;{{ business_plus_amount }}</b> / member
              </div>
            </div>
          </v-toolbar>
          <v-card>
            <v-container>
              <v-list flat>
                <v-list-item-group>
                  <v-list-item text--purple id="clrClass">
                    <v-icon small color="#c89d36">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">Unlimited Team Members</h5>
                  </v-list-item>
                  <v-list-item class="mt-n4" id="clrClass">
                    <v-icon small color="#c89d36">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">
                      Unlimited Projects
                    </h5></v-list-item
                  >
                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#c89d36">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">Time Tracking</h5></v-list-item
                  >
                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#c89d36">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">Smart Chatbox</h5></v-list-item
                  >
                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#c89d36">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">
                      Task List and Kanban View
                    </h5></v-list-item
                  >
                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#c89d36">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">Push-to-talk</h5></v-list-item
                  >

                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#c89d36">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">Reports</h5></v-list-item
                  >
                   <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#c89d36">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">Schedule Messages</h5></v-list-item
                  >
                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#c89d36">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">
                      Screen Recording
                    </h5></v-list-item
                  >
                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#c89d36">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">
                      Multiple App Integrations
                    </h5></v-list-item
                  >
                 
                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#c89d36">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">
                      Custom Subdomain
                    </h5></v-list-item
                  >
                  <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#c89d36">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">
                      1 Month trial with Credit Card
                    </h5></v-list-item
                  >
                </v-list-item-group>
              </v-list>
              <div class="d-flex align-center justify-center">
                <!-- Button for Business Plus Yearly Plan Subscription -->
                <v-btn
                  width="233px"
                  class="mb-4"
                  dark
                  color="#c89d36"
                  @click="openModel('business_plus')"
                  >Subscribe Now</v-btn
                >
              </div>
            </v-container>
          </v-card>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="3" xl="3">
        <!-- Card for Enterprise Plan Features -->
        <v-card
          style="border-radius: 5%"
          :class="$vuetify.breakpoint.lgAndDown ? 'mb-1 mx-1' : 'mx-16 mb-1'"
        >
          <v-toolbar
            height="138px"
            class="d-flex justify-center"
            style="background-color: #d8fce8"
          >
            <div class="d-flex flex-column text-center">
              <div>
                <h2 style="color: #36454f;font-size: 27px;">On Premises Solution</h2>
              </div>
            </div>
          </v-toolbar>
          <v-card>
            <v-list flat>
              <v-list-item-group>
                <v-list-item id="clrClass"
                  ><v-icon small color="#4eb080">mdi-check-bold</v-icon>
                  <h5 class="listingDistance">Unlimited Team Members</h5>
                </v-list-item>
                <v-list-item class="mt-n4" id="clrClass"
                  ><v-icon small color="#4eb080">mdi-check-bold</v-icon>
                  <h5 class="listingDistance">
                    Unlimited Projects
                  </h5></v-list-item
                >
                <v-list-item class="mt-n4" id="clrClass"
                  ><v-icon small color="#4eb080">mdi-check-bold</v-icon>
                  <h5 class="listingDistance">Time Tracking</h5></v-list-item
                >
                <v-list-item class="mt-n4" id="clrClass"
                  ><v-icon small color="#4eb080">mdi-check-bold</v-icon>
                  <h5 class="listingDistance">Smart Chatbox</h5></v-list-item
                >
                <v-list-item class="mt-n4" id="clrClass"
                  ><v-icon small color="#4eb080">mdi-check-bold</v-icon>
                  <h5 class="listingDistance">
                    Task List and Kanban View
                  </h5></v-list-item
                >
                <v-list-item class="mt-n4" id="clrClass"
                  ><v-icon small color="#4eb080">mdi-check-bold</v-icon>
                  <h5 class="listingDistance">Push-to-talk</h5></v-list-item
                >

                <v-list-item class="mt-n4" id="clrClass"
                  ><v-icon small color="#4eb080">mdi-check-bold</v-icon>
                  <h5 class="listingDistance">Reports</h5></v-list-item
                >
                   <v-list-item class="mt-n4" id="clrClass"
                    ><v-icon small color="#4eb080">mdi-check-bold</v-icon>
                    <h5 class="listingDistance">Schedule Messages</h5></v-list-item
                  >
                <v-list-item class="mt-n4" id="clrClass"
                  ><v-icon small color="#4eb080">mdi-check-bold</v-icon>
                  <h5 class="listingDistance">Screen Recording</h5></v-list-item
                >
                <v-list-item class="mt-n4" id="clrClass"
                  ><v-icon small color="#4eb080">mdi-check-bold</v-icon>
                  <h5 class="listingDistance">
                    Multiple App Integrations
                  </h5></v-list-item
                >
              
                <v-list-item class="mt-n4" id="clrClass"
                  ><v-icon small color="#4eb080">mdi-check-bold</v-icon>
                  <h5 class="listingDistance">Custom Subdomain</h5></v-list-item
                >
                <v-list-item class="mt-n4" id="clrClass"
                  ><v-icon small color="#4eb080">mdi-check-bold</v-icon>
                  <h5 class="listingDistance">
                    On-premesis Deployment
                  </h5></v-list-item
                >
              </v-list-item-group>
            </v-list>
            <div class="d-flex align-center justify-center">
              <!-- Button for Enterprise Plan Contact -->
              <v-btn width="233px" class="mb-4" dark color="#4eb080"
                ><a target="_blank" href="https://gigstimer.com/contact-us/">
                  Contact Sales</a
                ></v-btn
              >
            </div>
          </v-card>
        </v-card>
      </v-col>
    </v-row>
    <!-- importation of snack bar -->
    <div>
      <SnackbarNew
        :snackbar.sync="snackbar"
        :snackbarError="snackbarError"
        :snackbarMessage="snackbarMessage"
      />
    </div>
  </div>
</template>
<script>
import PaymentMethodMixin from "@/components/Payment/PaymentMethodMixin";
import { snackbarMixin } from "@/mixins/snackbarMixin";
import { eventBus } from "@/main";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      planPeriod: "month",
    };
  },
  mixins: [PaymentMethodMixin, snackbarMixin],
  components: {
    SnackbarNew: () => import("@/components/Includes/SnackbarNew"),
  },
  computed: {
    ...mapGetters(["getSelectedCompany", "getActiveMembers"]),
    //switching over monthly and annual stripe plan
    professional_amount() {
      return this.cardDetail.stripe_plan === "monthly" ? "5.49" : "59.88";
    },
    business_plus_amount() {
      return this.cardDetail.stripe_plan === "monthly" ? "9.99" : "107.88";
    },
  },
  mounted() {
    this.stripeInvoiceListing();
  },
  methods: {
    //Function for adding credit card details for purchasing selected subscription
    openModel(product) {
      this.product = product;
      this.selectPayment();
    },
    // Function for puruchasing subscribtion, if subscribed_plan is null or basic, open dialog to add card details, otherwise update subscription plan
    selectPayment() {
      if (
        this.getSelectedCompany.subscribed_plan == null ||
        (this.getSelectedCompany.subscribed_plan &&
          (this.getSelectedCompany.subscribed_plan.toLowerCase() == "basic" || this.getSelectedCompany.subscribed_plan.toLowerCase()=="unlimited_plan"))
      ) {
        let product = this.product;
        setTimeout(
          eventBus.$emit("selectedPlan", {
            plan: this.cardDetail.stripe_plan,
            product: product,
            amount: this[product + "_amount"],
          }),
          3000
        );
      } else {
        // update subscription
        this.update_payment_card();
      }
    },
    //Function for update subscription plan
    update_payment_card() {
      if (this.planPeriod == "month") {
        if (this.product == "professional") {
          var data = {
            company_id: this.getSelectedCompany.id,
            plan: "professional_monthly",
          };
        }
        if (this.product == "business_plus") {
          var data = {
            company_id: this.getSelectedCompany.id,
            plan: "business_plus_monthly",
          };
        }
      }
      if (this.planPeriod == "year") {
        if (this.product == "professional") {
          var data = {
            company_id: this.getSelectedCompany.id,
            plan: "professional_yearly",
          };
        }
        if (this.product == "business_plus") {
          var data = {
            company_id: this.getSelectedCompany.id,
            plan: "business_plus_yearly",
          };
        }
      }
      this.$store
        .dispatch("update_payment_card", data)
        .then((response) => {
          this.openSnackbar(false, response.data.message);
          this.stripeInvoiceListing();
          this.$store.dispatch("fetchAllCompaniesList").then((response) => {
            if (response.status == 200) {
              eventBus.$emit("updatePlan", false);
              eventBus.$emit("switchTab", "gateway-tab");

              // this.$router.push({ name: "checkout" });
            }
          });
        })
        .catch((error) => {
          this.paymentIntent();
          this.openSnackbar(true, error.response.data.message);
        });
    },
  },
};
</script>

<style>
.hover-btn:hover {
  background-color: #e4f6f2 !important;
}
.active {
  color: white;
  background-color: #2a206a;
}

#clrClass {
  color: #36454f !important;
  cursor: auto;
}
.v-application a {
  color: white;
  text-decoration: none;
}
.listingDistance {
  margin-left: 10px;
}
</style>
